/**
 * HR demographic fields captured manually on the People profile.
 *
 * These are optional, self-identified values used for aggregate HR reporting only.
 * Keep the lists in sync with backend/constants/hr-demographics.constants.js.
 */
export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];

export const INDIGENOUS_STATUS_OPTIONS = [
  'Aboriginal',
  'Torres Strait Islander',
  'Both',
  'None',
];

export const COUNTRY_OF_BIRTH_OPTIONS = ['Australia', 'New Zealand', 'Other'];

export const DISABILITY_STATUS_OPTIONS = [
  'Disability requiring adjustment',
  'Disability not requiring adjustment',
  'None',
];

export const WORK_LOCATION_OPTIONS = ['NSW', 'QLD'];
